import { decodeFromBase64 } from "@medicusunion/front-utils";
import { i18n } from "i18next";
import { v4 as uuid } from 'uuid';
import { AVAILABLE_LANGUAGES } from "@/constants/languages";
import { logger } from "@/services/logger";
import { userIdStorage, tokenStorage, refreshTokenStorage, localeStorage, isDoctorStorage } from "./storage";

export const cleanLangQueryParam = (search: URLSearchParams, i18n: i18n) => {
  const updates: { shouldReplace: boolean } = { shouldReplace: false };

  let lang = search.get('lang') || localeStorage.getItem() || 'en';

  if (!AVAILABLE_LANGUAGES.includes(lang)) {
    lang = AVAILABLE_LANGUAGES[0];
  }

  localeStorage.setItem(lang);
  i18n.changeLanguage(lang);
  if (search.has('lang')) {
    search.delete('lang');
    updates.shouldReplace = true;
  }

  return updates.shouldReplace ? search : null;
};

export const cleanQueryParams = (search: URLSearchParams, i18n: i18n) => {
  const updates: { shouldReplace: boolean } = { shouldReplace: false };

  // User ID
  let userId = userIdStorage.getItem();
  if (!userId) {
    userId = uuid();
    userIdStorage.setItem(userId);
  }

  logger.setUser({
    id: userId,
  });

  // Token
  const token = decodeFromBase64(search.get('t'));
  if (token) {
    tokenStorage.setItem(token);
    search.delete('t');
    updates.shouldReplace = true;
  }

  // Refresh token
  const refreshToken = decodeFromBase64(search.get('r'));
  if (refreshToken) {
    refreshTokenStorage.setItem(refreshToken);
    search.delete('r');
    updates.shouldReplace = true;
  }

  // Language
  let lang = search.get('lang') || localeStorage.getItem() || 'en';

  if (!AVAILABLE_LANGUAGES.includes(lang)) {
    lang = AVAILABLE_LANGUAGES[0];
  }

  localeStorage.setItem(lang);
  i18n.changeLanguage(lang);
  if (search.has('lang')) {
    search.delete('lang');
    updates.shouldReplace = true;
  }

  // Role
  if (search.get('creator') === 'doctor') {
    isDoctorStorage.setItem('1');
    updates.shouldReplace = true;
  }

  return updates.shouldReplace ? search : null;
};

export const replaceQueryState = (search: URLSearchParams, pathname: string) => {
  const queryString = search.toString();
  const newUrl = `${pathname}${queryString ? `?${queryString}` : ''}`;
  window.history.replaceState({}, '', newUrl);
};
